<router-outlet></router-outlet>
<app-toast></app-toast>
<div  class="border border-primary rounded-circle bg-primary text-white" style="position: fixed;z-index: 10;
right:    1%;
bottom:   2%;
"><i class="bx bx-support bx-md m-2"></i></div>
<app-add-store-pop-up></app-add-store-pop-up>